var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yhbpknzraa)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.04 2.423a.963.963 0 0 1 0 1.362l-3.22 3.22 3.84 3.838 3.219-3.219a.963.963 0 1 1 1.362 1.362l-3.22 3.22 1.92 1.92a.963.963 0 0 1 0 1.361l-3.25 3.25c-3.007 3.007-7.785 3.221-11.044.643L4.34 20.688a.963.963 0 0 1-1.362-1.362l1.308-1.309C1.707 14.76 1.92 9.98 4.927 6.974l3.25-3.25a.963.963 0 0 1 1.363 0l1.919 1.918 3.219-3.219a.963.963 0 0 1 1.362 0zm-5.286 5.239L8.858 5.767l-2.57 2.569c-2.48 2.482-2.483 6.546-.008 9.031l.009.009.008.008c2.486 2.476 6.55 2.473 9.032-.008l2.57-2.57-1.897-1.895a.893.893 0 0 1-.047-.048L10.802 7.71a.994.994 0 0 1-.048-.048z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yhbpknzraa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.48da8ef1e412998dfac858eb453503c6.svg";
export { ForwardRef as ReactComponent };